import { Expose } from "class-transformer";
import { User } from "../user/user";

export class Notes {
    @Expose() id: string | undefined;
    @Expose() TicketId!:string|undefined;
    @Expose() objectID: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() noteText: string | undefined;
    @Expose() noteTypeId: string | undefined;
    @Expose() noteModuleCode: string | undefined;
    @Expose() updatedOn: string | undefined;
    @Expose() updatedById: string | undefined;
    headColor?:string | undefined;
    attachment: boolean | undefined;;
    files?: File[]=[];
    attachments?: NoteAttachments[] =[];
    userName?: string | undefined;
    userPic?: string | undefined;
    mentionUserIdList?:string[] | undefined;
    noteType?:string | undefined;
    noteTypeCode?:string | undefined;
}

export class CreateNote {
  @Expose() objectID: string | undefined;
  @Expose() businessId: string | undefined;
  @Expose() TicketId!:string|undefined;
  @Expose() noteTypeId: string | undefined;
  @Expose() noteText: string | undefined;
  @Expose() noteModuleCode: string | undefined;
  @Expose() updatedOn: string | undefined;
  @Expose() updatedById: string | undefined;
  mentionUserIdList?:string[] | undefined;
  }

  export class UpdateNote {
    @Expose() id: string | undefined;
    @Expose() objectID: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() noteTypeId: string | undefined;
    @Expose() noteText: string | undefined;
    @Expose() noteModuleCode: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
    }

export class IFileUpload {
    noteAttachmentsKey: number;
    RequestID: string;
    AttachmentName: string;
    AttachmentBlobName: string;
    AttachmentContent: any;
    FormType: string;
    AttachmentFlag: boolean;
  }

  export class NoteAttachments {
    path: string;

  }
